import { render, staticRenderFns } from "./TourGallerySlider.vue?vue&type=template&id=01e4a1a3&scoped=true&"
import script from "./TourGallerySlider.vue?vue&type=script&lang=js&"
export * from "./TourGallerySlider.vue?vue&type=script&lang=js&"
import style0 from "./TourGallerySlider.vue?vue&type=style&index=0&id=01e4a1a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e4a1a3",
  null
  
)

export default component.exports